import { Box, Link } from '@mui/material'
import CompliancePlip from '../../../../components/CompliancePlip'
import { ComplianceStatus } from '../../../../types'
import useCustomer from '../../../../hooks/useCustomer'

interface MedicalWasteProps {
  link: string
}

const MedicalWaste = ({ link }: MedicalWasteProps) => {
  const customer = useCustomer()
  const metadata = customer.customerMetadata

  return metadata && (
    <Box>
      <div className='border-box'>
        <div>
          <CompliancePlip message='' className='dashboard-compliance' status={metadata.mwaste_status ?? ComplianceStatus.Inactive} />
        </div>
        <div className='compliance-message'>
          <p className='card-info'>{metadata.mwaste_message_long}</p>
          <Link className='small-text' href={link}>{metadata.mwaste_status === ComplianceStatus.Inactive ? 'Learn More' : 'View Details'}</Link>
        </div>
      </div>
      <div className='card-footer flex justify-between'>
        {metadata.mwaste_available_containers > 0 && (
          <div>
            <span className="block text-ot-dashboard">{metadata.mwaste_available_containers}</span>
            <span className="text-base">In Use</span>
          </div>
        )}
        {metadata.mwaste_destroyed_containers > 0 && (
          <div className="center-text">
            <span className="block text-lg">{metadata.mwaste_destroyed_containers}</span>
            <span className="text-base">Processed</span>
          </div>
        )}
      </div>
    </Box>
  )
}

export default MedicalWaste